<section class="drilldown">
  <div class="fieldArea" [formGroup]="childForm">
    <ng-container>
      <br />
      <div style="width: 50%; float: right">
        <label>Enable:</label>
        <mat-slide-toggle
          name="Enable"
          color="primary"
          (change)="buildAggregateData()"
          formControlName="drilldownEnabled"
          style="float: right; margin-right: 20px"
        >
        </mat-slide-toggle>
      </div>
      <br />
      <ng-container
        *ngIf="childForm && childForm.get('drilldownEnabled').value"
      >
        <div style="width: 98%">
          <label>Send user to:</label>
        </div>

        <div style="width: 98%">
          <mat-form-field appearance="fill" style="width: 95%">
            <mat-select
              (selectionChange)="changeFlow()"
              formControlName="drilldownLinkType"
              placeholder="Please select the navigation destination"
              [disabled]="workflows.data.length <= 0"
            >
              <mat-option value="workflow" *ngIf="workflows.data.length >= 1">
                Workflows
              </mat-option>
              <mat-option value="dataset"> Record Page </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          style="width: 98%"
          *ngIf="childForm.get('drilldownLinkType').value == 'workflow'"
        >
          <ng-container>
            <mat-form-field appearance="fill" style="width: 95%">
              <mat-select
                formControlName="drilldownLinkId"
                placeholder="Please select an workflow"
                floatPlaceholder="never"
                (selectionChange)="buildAggregateData()"
              >
                <mat-optgroup
                  *ngFor="let group of workflows.data"
                  [label]="group.dataset"
                >
                  <mat-option
                    *ngFor="let data of group.workflows"
                    [value]="data.id"
                  >
                    {{ data.name }}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </div>
        <div
          style="width: 98%"
          *ngIf="childForm.get('drilldownLinkType').value == 'dataset'"
        >
          <mat-form-field appearance="fill" style="width: 95%">
            <mat-select
              formControlName="drilldownLinkId"
              placeholder="Please select a data point"
              floatPlaceholder="never"
              (selectionChange)="buildAggregateData()"
              [disabled]="currentDataSets.length == 1"
            >
              <mat-option
                *ngFor="let data of currentDataSets"
                [value]="data.id"
              >
                {{ data.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>
    <div
      class="notAvailable"
      *ngIf="chartType && chartType.toLowerCase() != 'table'"
    >
      The page links will only appear in the chart drilldown when choosing a
      datapoint
    </div>
  </div>
</section>
